import { ChiefComplaintQuestion } from '@/Mixins/BaseInformation/ChiefComplaint/Question.mixin';
import ChiefComplaintMixin from '@/Mixins/BaseInformation/ChiefComplaintMixin';
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      disabelConfirm: false,
      addFlag: false,
      isActive: false,
      modalTitle: '',
      showAddEditModal: false,
      searchModal: false,
      isSearch: false,
      modalIcon: '',
      chiefComplaintQuestionHeaders: [
        { text: 'اولویت', value: 'priority', align: 'center' },
        { text: 'عنوان سوال', value: 'title', align: 'center' },
        {
          text: 'ارجاع به',
          value: 'otherChiefComplaintTitle',
          align: 'center',
        },
        {
          text: 'متن ارجاع',
          value: 'otherChiefComplaintText',
          align: 'center',
        },
        { text: 'وضعیت', value: 'isActive', align: 'right' },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],
      searchCategory: null,
      searchText: this.$route.query?.['title'] || '',
      chiefComplaintphoneNumbers: [],
      selectedQuestion: -1,
    };
  },
  mixins: [ChiefComplaintMixin],
  methods: {
    selectQuestion(id) {
      this.selectedQuestion = id;
    },
    onModalValidation: function () {
      if (!this.chiefComplaintQuestion.title) {
        this.snackText = 'عنوان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.chiefComplaintQuestion.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.chiefComplaintQuestion.priority?.toString()) {
        this.snackText = 'اولویت نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (
        this.haveReferenceQuestion &&
        !this.chiefComplaintQuestion.otherChiefComplaintId?.toString()
      ) {
        this.snackText = 'ارجاع نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (this.haveReferenceQuestion && !this.chiefComplaintQuestion?.otherChiefComplaintText) {
        this.snackText = 'متن ارجاع نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      this.chiefComplaintQuestion.chiefComplaintId = +this.$route.params?.id;
      return true;
    },
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.modalTitle = 'افزودن پرسش کلیدی';
        this.modalIcon = 'mdi-plus';
        this.addFlag = true;
        this.confimType = 'add';
      } else if (type == 2) {
        this.modalTitle = 'ویرایش پرسش کلیدی';
        this.modalIcon = 'mdi-pencil';
        this.confimType = 'edit';
        this.addFlag = false;
        this.selectQuestion(id);
        this.getQuestionHandler(id);
      }
      this.showAddEditModal = true;
    },
    cancelAddEditFunction: function () {
      this.isActive = false;
      this.showAddEditModal = false;
    },
    resetSelected() {
      this.selectQuestion(-1);
    },
    onAcceptModal: function () {
      if (this.confimType === 'add') this.createQuestionHandler();
      else if (this.confimType === 'edit') this.editQuestionHandler();
    },
    showConfirmDialogFunction: function () {
      if (this.confimType === 'makeActive') {
        this.$refs.confirm.title = 'فعال کردن سوال';
        this.$refs.confirm.text = 'آیا از فعال کردن سوال اطمینان دارید؟';
      } else if (this.confimType == 'makeDeactive') {
        this.$refs.confirm.title = 'غیر کردن سوال';
        this.$refs.confirm.text = 'آیا از غیر فعال کردن سوال اطمینان دارید؟';
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف سوال';
        this.$refs.confirm.text = 'از حذف سوال اطمینان دارید؟';
      }
      this.$refs.confirm.showConfirmDialog = true;
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      this.disabelConfirm = false;
      if (this.confimType === 'makeActive') {
        this.activeQuestionHandler(this.selectedQuestion);
      } else if (this.confimType === 'makeDeactive') {
        this.deactiveQuestionHandler(this.selectedQuestion);
      } else if (this.confimType === 'delete') this.deleteQuestionHandler(this.selectedQuestion);
      this.confirmDialogCancelFunction();
    },
    confirmDialogCancelFunction: function () {
      this.$refs.confirm.showConfirmDialog = false;
      this.disabelConfirm = false;
    },
    //delete
    showDeleteConfirmFunction: function (id) {
      this.selectQuestion(id);
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
    // set status
    changeQuestionStatus: function (status, id) {
      const type = status ? 'makeDeactive' : 'makeActive';
      this.selectQuestion(id);
      this.confimType = type;
      this.showConfirmDialogFunction();
    },
    // reset question
    resetQuestion: function () {
      this.chiefComplaintQuestion = new ChiefComplaintQuestion('', null, null, null, -1);
    },
    getPageTitle: function () {
      const chiefComplaintId = this.$route.params?.id;
      this.getChiefComplaintFunction(chiefComplaintId);
    },
  },
  mounted() {
    this.getPageTitle();
  },
  computed: {
    questionPriority: function () {
      return Array.from({ length: this.allQuestionsList.length + 1 }, (_, index) => index + 1);
    },
    filterdAllQuestions: function () {
      return [...this.allQuestionsList].filter(({ title }) => title.includes(this.searchText));
    },
  },
  watch: {
    showAddEditModal: function (currentVal) {
      if (!currentVal) {
        this.resetSelected();
        this.haveReferenceQuestion = false;
        this.resetQuestion();
      }
    },
    haveReferenceQuestion: function (currentVal) {
      if (currentVal) this.getAllChiefComplaints();
    },
    searchText: function (currentVal) {
      if (currentVal) this.$router.replace({ query: { title: currentVal } });
      else if (!currentVal) this.$router.replace({ query: {} });
    },
    'chiefComplaintQuestion.otherChiefComplaintId': function (currentVal) {
      if (currentVal) this.haveReferenceQuestion = true;
    },
  },
};
